export default (t) => [
  {
    text: t('Invoice No.'),
    value: 'invoice_no',
    sortable: false,
    width: 200,
    togglable: true
  },
  {
    text: t('Bill No.'),
    value: 'bill_no',
    sortable: false,
    width: 180,
    togglable: true
  },
  {
    text: t('Branch'),
    value: 'branch',
    sortable: false,
    width: 140,
    togglable: true
  },
  {
    text: t('Customer'),
    value: 'customer',
    sortable: false,
    width: 220,
    togglable: true
  },
  {
    text: t('Amount'),
    value: 'total_amount',
    sortable: false,
    width: 130,
    togglable: true
  },
  {
    text: t('Issued At'),
    value: 'created_at',
    sortable: true,
    width: 170,
    togglable: true
  },
  {
    text: t('Status'),
    value: 'status',
    sortable: false,
    width: 200,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 90
  }
];
